import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Manager from './pages/Manager';
import History from './pages/History';
import Customers from './pages/Customers';
import Skills from './pages/Skills';
import Groups from './pages/Groups';
import WebPhone from './pages/WebPhone';
import Sidebar from './components/Sidebar';

const AppLayout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      minHeight: '100vh',
      flexDirection: isMobile ? 'column' : 'row'
    }}>
      <Sidebar />
      <main style={{
        flex:1,
        padding: isMobile ? '1rem' : '2rem',
        background: 'linear-gradient(135deg, #111827 0%, #1f2937 50%, #374151 100%)',
        overflow: 'auto',
        minHeight: '100vh',
        color: '#e2e8f0',
        width: isMobile ? '100%' : 'auto',
        maxWidth: '100%',
      }}>
        {children}
      </main>
    </div>
  );
};

const RootRedirect = () => {
  const { isAdmin } = useAuth();
  return <Navigate to={isAdmin ? '/dashboard' : '/webphone'} />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <AppLayout>
                  <Dashboard />
                </AppLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/manager"
            element={
              <PrivateRoute requireAdmin={true}>
                <AppLayout>
                  <Manager />
                </AppLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/history"
            element={
              <PrivateRoute requireAdmin={true}>
                <AppLayout>
                  <History />
                </AppLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute requireAdmin={true}>
                <AppLayout>
                  <Users />
                </AppLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/skills"
            element={
              <PrivateRoute requireAdmin={true}>
                <AppLayout>
                  <Skills />
                </AppLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/groups"
            element={
              <PrivateRoute requireAdmin={true}>
                <AppLayout>
                  <Groups />
                </AppLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <PrivateRoute requireAdmin={true}>
                <AppLayout>
                  <Customers />
                </AppLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/webphone"
            element={
              <PrivateRoute>
                <AppLayout>
                  <WebPhone />
                </AppLayout>
              </PrivateRoute>
            }
          />
          <Route path="/" element={<RootRedirect />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
